// Helpers shared by the combine bundle purchase paths: the payment widgets,
// CombineBundleStep, Payment.jsx's bundle fallback and the dashboard modal.
// Kept free of service imports so pages and their tests can use them without
// loading the widget.

export const bundleSuccessMessage = (bundleChoice) => {
  const combineNames = (bundleChoice.combines || [])
    .map((combine) => combine.name)
    .filter(Boolean);
  const drillNames = (bundleChoice.combines || [])
    .filter((combine) => combine.hasPositionDrills)
    .map((combine) => combine.name)
    .filter(Boolean);

  return (
    `You're registered for ${combineNames.join(", ")}.` +
    (drillNames.length
      ? ` Position drills are included at ${drillNames.join(", ")}.`
      : "")
  );
};

// Set when IntelliPay charged the card for a bundle but registration or the
// bundle purchase then failed. While it is set, the bundle must not be
// offered for payment again — including after a reload — or the athlete is
// charged twice. Cleared by localStorage.clear() when a new registration starts.
const BUNDLE_CHARGED_BUT_INCOMPLETE_KEY = "bundleChargedButIncomplete";

// Never throws: it runs after the card has been charged, and blocked or full
// storage must not stop the athlete from seeing the transaction id. The
// in-page lock (onChargedButIncomplete) still applies; only the
// survive-a-reload part is lost.
export const markBundleChargedButIncomplete = (transactionId, bundleId) => {
  try {
    localStorage.setItem(
      BUNDLE_CHARGED_BUT_INCOMPLETE_KEY,
      JSON.stringify({ transactionId, bundleId }),
    );
  } catch {
    // Storage unavailable; nothing more to do here.
  }
};

export const readBundleChargedButIncomplete = () => {
  try {
    return JSON.parse(
      localStorage.getItem(BUNDLE_CHARGED_BUT_INCOMPLETE_KEY) || "null",
    );
  } catch {
    return null;
  }
};

export const chargedButIncompleteMessage = (transactionId) =>
  "Your payment went through, but we couldn't complete your registration. " +
  (transactionId
    ? `Please contact support with transaction ID ${transactionId}.`
    : "Please contact support.");
